import { render } from "./MFACreateForm.vue?vue&type=template&id=b6a3b1a2"
import script from "./MFACreateForm.vue?vue&type=script&lang=js"
export * from "./MFACreateForm.vue?vue&type=script&lang=js"
script.render = render

export default script